<div class="flex flex-col gap-[16px]">
  <app-feature-details-grid>
    <app-feature-list-container>
      <vi-item
        *ngIf="availableBufferModes"
        [title]="'+INSTALLATIONS.INSTALLATION.PANEL.BUFFER_TANK.MODE_TITLE' | translate"
        [asDropdown]="isOperatingModeEditable"
        [options]="availableBufferModes"
        [value]="selectedBufferTankMode"
        (valueChange)="onBufferTankModeChange($event)"
      ></vi-item>

      <app-feature-list-item
        *ngIf="bufferTankTemperatureMain$ | async | ready as feature"
        feature
        data-at-buffer-tank-temperature-main
        label="{{
          '+INSTALLATIONS.INSTALLATION.BUFFER_TANK_PROPERTIES.BUFFER_TEMPERATURE' | translate
        }}"
        value="{{
          feature | value2: featurePropertyKey.value | translateBufferTankOperatingMode
        }} {{ feature | unit: featurePropertyKey.value }}"
        [attr.data-feature]="feature.feature"
      >
      </app-feature-list-item>
    </app-feature-list-container>
  </app-feature-details-grid>
</div>
